export default {
      id: "close-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "sprite.svg#close-usage",
      toString: function () {
        return this.url;
      }
    }